<template lang="pug">
div
  el-form-item.mb-8(label="位数")
    el-input-number.width-full(v-model="ruleObj.length", :max="7", :min="1", step-strictly)
  el-form-item.mb-8(label="开始值")
    el-input-number.width-full(v-model="ruleObj.startValue", :key="ruleObj.length", v-bind="range")
  el-form-item.mb-8(label="超出位数后")
    el-select.width-full(v-model="ruleObj.overFlowRule")
      el-option(v-for="{ id, cnName } in limits", :key="id", :label="cnName", :value="id")
  el-form-item.mb-0(label="重置周期")
    el-select.width-full(v-model="ruleObj.resetRule")
      el-option(v-for="{ id, cnName } in repeats", :key="id", :label="cnName", :value="id") {{ cnName }}
</template>
<script>
import { baseMixin } from "./index.js";
export default {
  mixins: [baseMixin],
  data() {
    return {
      limits: [
        { cnName: "继续编号", id: 0 },
        { cnName: "重新计数", id: 1 }
      ],
      repeats: [
        { cnName: "不重置", id: 0 },
        { cnName: "每天重置", id: 1 },
        { cnName: "每月重置", id: 2 },
        { cnName: "每年重置", id: 3 }
      ]
    };
  },
  computed: {
    ruleObj() {
      return this.data.serialNoRule;
    },
    range() {
      const {
        ruleObj: { length }
      } = this;
      return { max: 10 ** length - 1, min: 1 };
    }
  }
};
</script>
<style lang="scss" scoped src="./index.scss"></style>
